import { render, staticRenderFns } from "./hotWord.vue?vue&type=template&id=304939e8&scoped=true"
import script from "./hotWord.vue?vue&type=script&lang=ts"
export * from "./hotWord.vue?vue&type=script&lang=ts"
import style0 from "./hotWord.vue?vue&type=style&index=0&id=304939e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304939e8",
  null
  
)

export default component.exports